import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';
import {
    showAllStrategies,
    showStrategyEditor,
    showPersonalStrategy,
    closeStrategyEditor,
    updateStategyDetails,
    saveNewStrategy,
    loadPersonalStrategiesFromNew
} from '../../../actions/data';
import './StrategyList.css';
import i18n from './../../../i18n';
import StrategyRow from './StrategyRow.js';
import StrategyEditor from 'wt-react/dist/components/StrategyEditor/StrategyEditor';


import 'react-tabs/style/react-tabs.css';

export const KEY_METRICS = [
    'performance',
    'income',
    'risk',
    'sharpe',
    'fees',
]

class StrategyList extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            menuIsOpen: false,
            currPage: 0,
            numPerPage: 10,
            searchTerm: '',
            savingNewStrategy: false,
            savingNewStrategyValue: null

        };

        this.paginate = this.paginate.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        ReactTooltip.rebuild();
        const { strategyIdToShow } = this.props.data;
        // if personalStrategies has been updated/loaded, and user has an id in the url, then we want to open it
        if (this.props.data.personalStrategies !== prevProps.data.personalStrategies) {
            const { personalStrategies } = this.props.data;
            if (personalStrategies && personalStrategies.length > 0) {
                this.readURL();
            }
        }

        if (prevProps.data.strategyIdToShow !== strategyIdToShow && (strategyIdToShow === false || strategyIdToShow === null || strategyIdToShow === undefined)) {
            const { history } = this.props;
            const hash = history.location.hash.substring(1);

            if (hash !== '') {
                const hash2 = hash.split('&');

                // Filter out the id parameter
                const newHashArray = hash2.filter(param => !param.startsWith('id='));
                const newHash = newHashArray.join('&');

                // Update the URL without the id parameter
                history.replace({ hash: newHash });
            }
        }
    }

    setSavingStrategyInProgress = (value, isSaving) => {
        const { personalStrategies } = this.props.data;
        const updatedStrategies = [value, ...personalStrategies];

        if (!isSaving && value) {
            this.props.loadPersonalStrategiesFromNew(updatedStrategies)
        }

        this.setState({ savingNewStrategy: isSaving, savingNewStrategyValue: value })
    };

    readURL = () => {
        const { history } = this.props;
        const hash = history.location.hash.substring(1);

        if (hash !== '') {
            const hash2 = hash.split('&');

            // check if 'id=' is in hash2 = [#my-portoflio-hub, id=1234]
            const idParam = hash2.find(param => param.startsWith('id='));

            if (idParam) {
                const id = idParam.split('=')[1];
                //load up the id into redux and open to show the user
                this.props.showPersonalStrategy(id);
            }
        }
    }

    setMenuIsOpen = (menuIsOpen) => {
        this.setState({ menuIsOpen });
    };

    paginate({ selected }) {
        this.setState({
            currPage: selected,
        });
    }

    handleSearchChange(event) {
        this.setState({ searchTerm: event.target.value });
    }

    handleClearSearch = () => {
        this.setState({ searchTerm: '' });
    }

    render() {
        const {
            currPage,
            numPerPage,
            savingNewStrategy,
            savingNewStrategyValue,
        } = this.state;

        const {
            params,
        } = this.props;

        const {
            personalStrategies,
            strategyIdToShow,
            strategySaveInProgress,
        } = this.props.data;


        if (savingNewStrategy || (personalStrategies && personalStrategies.length) > 0) {
            const filteredStrategies = personalStrategies
                ?.filter(strategy => strategy?.name && strategy.name.toLowerCase().includes(this.state?.searchTerm.toLowerCase()));

            const min = currPage * numPerPage;
            const max = min + numPerPage;
            const pageCount = Math.ceil(filteredStrategies?.length / numPerPage);
            const personalStrategiesToList = filteredStrategies?.slice(min, max);


            return (
                <div className='strategylistPS'>

                    {!this.state.menuIsOpen && (<div className='row'>
                        <div className='title-heading col-sm-12'>{i18n.t('title-heading')}</div>
                        <div className='title-subheading col-sm-12'>{i18n.t('title-subheading')}</div>
                    </div>)}

                    {!this.state.menuIsOpen && (
                        <div className='search-container'>
                            <input
                                type="text"
                                placeholder="Search by Portfolio Name"
                                value={this.state.searchTerm}
                                onChange={this.handleSearchChange}
                                className="search-input"
                            />
                            <button onClick={this.handleClearSearch} className="clear-button">Clear</button>
                        </div>
                    )}
                    {!strategyIdToShow ?
                        <div className='headers'>
                            <div className='menu title'>{i18n.t('name')}
                            </div>
                            <div className='name title'></div>
                            <div className='last-updated title'>{i18n.t('last-updated')}</div>
                            <div className='inception-date title'>{i18n.t('inception-date')}</div>
                            <div className='statistics'>
                                {
                                    KEY_METRICS.map(metric => {
                                        return (
                                            <div className={'stat-' + metric} key={'stat-' + metric}>
                                                <div className='stat-heading'>
                                                    <div className='title'>{i18n.t(metric)}</div>
                                                    <div className='more-info' >
                                                        <FontAwesomeIcon data-tip data-for={metric + '-desc'} icon='question-circle' size='sm' />
                                                    </div>
                                                </div>
                                                <ReactTooltip id={metric + '-desc'} type='light' className='tooltip' effect='float'>
                                                    {i18n.t(metric + '-desc')}
                                                </ReactTooltip>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        : null}

                    {savingNewStrategy && (
                        <StrategyRow
                            personalStrategy={savingNewStrategyValue}
                            openMenu={false}
                            key={1}
                            striped={1}
                            saveInProgress={true}
                            menuIsOpen={false}
                            setMenuIsOpen={null}
                        />
                    )}

                    {personalStrategiesToList?.map((strategy, index) => {
                        // Check if the strategy name matches the new strategy value name
                        if (strategy.name === savingNewStrategyValue?.name && savingNewStrategy) {
                            return null; // Skip this iteration
                        }

                        if (strategyIdToShow === null || strategy.id === strategyIdToShow) {
                            return (
                                <StrategyRow
                                    personalStrategy={strategy}
                                    openMenu={strategyIdToShow === null ? false : true}
                                    key={strategy.id}
                                    striped={index % 2 !== 0}
                                    saveInProgress={strategySaveInProgress && strategySaveInProgress === strategy.id}
                                    menuIsOpen={this.state.menuIsOpen}
                                    setMenuIsOpen={this.setMenuIsOpen}
                                />
                            );
                        } else {
                            return null;
                        }
                    })}



                    {!strategyIdToShow ?
                        <div className='last-row'>
                            <div className='row-pagination'>
                                <ReactPaginate
                                    previousLabel={<FontAwesomeIcon icon='chevron-left' size='xs' />}
                                    nextLabel={<FontAwesomeIcon icon='chevron-right' size='xs' />}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.paginate}
                                    containerClassName={'pagination'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-item'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'pageLink'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'pageLink'}
                                    activeClassName={'active'}
                                    disabledClassName={'disabled'}
                                />
                            </div>
                            <div className='new-strategy'>
                                <StrategyEditor
                                    key={'new-strategy-editor-1'}
                                    type={'create'}
                                    buttonLabel={i18n.t('new-strategy')}
                                    showEditor={true}
                                    token={params.token}
                                    clientEmail={params.clientEmail}
                                    dataspanApiUrl={`${process.env.REACT_APP_API_URL}`}
                                    checkTickersUrl={`${process.env.REACT_APP_DPD_URL}`}
                                    typeHeadPlaceholder={'Search By Ticker or Name'}
                                    savedStrategyCallBack={(value, isSaving) => this.setSavingStrategyInProgress(value, isSaving)}
                                    closeModalOnSave={true}
                                    showInfoModal={false}
                                />
                            </div>
                        </div>
                        : null}

                </div>
            );
        } else if (personalStrategies && personalStrategies.length === 0) {
            return (
                <div className='no-strategies'>
                    <div className='no-strategies-label'>
                        <h4>{i18n.t('no-strategies')}</h4>
                    </div>
                    <div className='new-strategy'>
                        {/* Add the 'ADD' button without passing in a PersonalStrategy to load into it */}
                        <StrategyEditor
                            key={'new-strategy-editor-1'}
                            type={'create'}
                            buttonLabel={i18n.t('new-strategy')}
                            showEditor={true}
                            token={params.token}
                            clientEmail={params.clientEmail}
                            dataspanApiUrl={`${process.env.REACT_APP_API_URL}`}
                            checkTickersUrl={`${process.env.REACT_APP_DPD_URL}`}
                            typeHeadPlaceholder={'Search By Ticker or Name'}
                            showInfoModal={true}
                            closeModalOnSave={true}
                            savedStrategyCallBack={(value, isSaving) => this.setSavingStrategyInProgress(value, isSaving)}

                        />
                    </div>
                </div>
            );
        }
        return (
            <div className='loading-strategies-hub'>
                <FontAwesomeIcon icon='circle-notch' size='2x' spin />
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        data: state.data,
        params: state.params,
    };
}

export default withRouter(connect(mapStateToProps,
    {
        showAllStrategies,
        showStrategyEditor,
        showPersonalStrategy,
        closeStrategyEditor,
        updateStategyDetails,
        saveNewStrategy,
        loadPersonalStrategiesFromNew
    })(StrategyList));